import { Routes, Route } from 'react-router-dom';
import DisplayEmailNotices from './components/emailNotices/DisplayEmailNotices';

function AppEmailNotices() {
    return (
        <Routes>
            <Route path="displayEmailNotices" element={<DisplayEmailNotices />} />			
        </Routes>
    );
}

export default AppEmailNotices;